module.exports = __webpack_public_path__ + "static/media/bs1.9013c3b1.webp";